import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./DepartmentsFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import DepartmentsFormStepTwo from "./DepartmentsFormSteps/DepartmentsFormStepTwo";
import DepartmentsFormStepOne from "./DepartmentsFormSteps/DepartmentsFormStepOne";
import { useEffect, useState } from "react";

const DepartmentsForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues:_initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
       ..._initialValues,
       category:_initialValues?.category?.uuid ? {value:_initialValues?.category?.uuid} : null,
       leader:_initialValues?.leader?.uuid ? {value:_initialValues?.leader?.uuid} : null,
       superiorDepartment:_initialValues?.superiorDepartment?.uuid ? {value:_initialValues?.superiorDepartment?.uuid} : null
      });
      return;
    }

    setInitialValues({
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="DepartmentsForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <DepartmentsFormStepOne {...formProps} {...props} />
              <DepartmentsFormStepTwo {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default DepartmentsForm;
